import { Box, Card, CardActionArea, CardContent, Chip, Typography } from '@mui/material'
import { ReportDto } from 'dtos'

interface Props {
  report: ReportDto
  onClick?: () => void
  cardId?: string
  actionId?: string
}

export default function ReportCard({ report, onClick, cardId, actionId }: Props) {
  const content = (
    <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box alignItems='center' display='flex' gap={1} mb={1}>
        <Typography fontWeight='bold' variant='h6'>
          {report.name}
        </Typography>
        <Chip color='primary' label='.csv' size='small' variant='outlined' />
      </Box>
      <Typography variant='body2'>{report.description}</Typography>
    </CardContent>
  )

  return (
    <Card
      id={cardId ?? `report-card-${report.reportGuid}`}
      sx={{
        height: 180,
        transition: theme => theme.transitions.create(['box-shadow', 'transform']),
        '&:hover': {
          boxShadow: 6,
          transform: 'translateY(-2px)'
        }
      }}
    >
      {onClick ? (
        <CardActionArea id={actionId ?? `report-card-open-${report.reportGuid}`} onClick={onClick} sx={{ height: '100%' }}>
          {content}
        </CardActionArea>
      ) : (
        content
      )}
    </Card>
  )
}
